module.exports = __webpack_public_path__ + "static/media/img_Benchmarking101.6afb0a69.png";